import { ReactComponent as PowderedSugarTopping } from './powdered_sugar_topping.svg'
import { ReactComponent as ChocolateSprinklesTopping } from './chocolate_sprinkles_topping.svg'
import { ReactComponent as StrawberrySprinklesTopping } from './strawberry_sprinkles_topping.svg'
import { ReactComponent as RainbowSprinklesTopping } from './rainbow_sprinkles_topping.svg'
import { ReactComponent as HeartCandyTopping } from './heart_candy_topping.svg'
import { ReactComponent as CerealTopping } from './cereal_topping.svg'

const DonutToppings = {
  PowderedSugarTopping,
  ChocolateSprinklesTopping,
  StrawberrySprinklesTopping,
  RainbowSprinklesTopping,
  HeartCandyTopping,
  CerealTopping,
}

export default DonutToppings
